import React, { useEffect, useRef, useState } from 'react';
import { ButtonBase } from '../elements';
import { ThemeTabs } from '../coupons/ThemeTabs';
import { ReactComponent as DeleteBackspaceIcon } from './delete_button_inner.svg';
import { FixtureSearch } from '../../models/api/codegen/code';
import { MatchBoxBySearch, MatchBoxBySearchMobile } from './MatchBoxBySearch';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { StoreType } from '../../store/spirs/types';
import { Keyboard } from './Keyboard';
import { getSearchResult } from '../../spirsApi/api-client';
import NumberUtils from '../../utils/NumberUtils';
import { SEARCH_VALUE } from '../../store/spirs/actions';
import { Mobile } from '../adaptive/Mobile';
import { Desktop } from '../adaptive/Desktop';

type Tab = 'ALL' | 'NOT_STARTED' | 'LIVE';

export const SearchComponent: React.FC<React.PropsWithChildren<{
    char: string;
    setOpen: (value: boolean) => void;
    goBack?: () => void;
    hideHeader?: boolean;
    currentTab?: Tab;
    onTabChange?: (tab: Tab) => void;
    checkWeb?: boolean;
}>> = props => {
    const { children, goBack, hideHeader = false, currentTab: externalCurrentTab, onTabChange, checkWeb = true } = props;
    const [internalCurrentTab, setInternalCurrentTab] = useState<Tab>('ALL');
    const currentTab = externalCurrentTab !== undefined ? externalCurrentTab : internalCurrentTab;
    const {
        search: inputValue,
        playerInfo: { web: isWeb }
    } = useSelector((state: StoreType) => state.spirs);
    const [foundFixtures, setFoundFixtures] = useState<FixtureSearch>();
    const inputRef = useRef<HTMLInputElement>(null);
    const { t } = useTranslation();
    const [charLen, setCharLen] = useState<number>(0);
    const dispatch = useDispatch();
    const setInputValue = (s: string) => dispatch(SEARCH_VALUE(s));

    useEffect(() => {
        if (inputValue && inputValue.length > 2) {
            getSearchResult({ value: inputValue })
                .then(res => res && setFoundFixtures(res))
                //  .then(res => {
                //     if (res) {
                //         // Моковое событие для Live
                //         const mockLiveEvent: any = {
                //             cn: 'Ахмат - Гонвед Будапешт',
                //             c: [],
                //             fi: 778,
                //             gm: [],
                //             p: [],
                //             r: false,
                //             sc: '#F97624BF',
                //             siu: '/path/to/icon',
                //             sid: 1,
                //             cid: 1,
                //             tid: 1,
                //             sn: 'Футбол',
                //             ctn: 'Международные',
                //             tn: 'Товарищеские матчи',
                //             s: 'LIVE',
                //             a: true,
                //             cl: false,
                //             su: null,
                //             ms: {
                //                 homeScore: 1,
                //                 awayScore: 0,
                //                 matchStatus: '2-й тайм',
                //                 eventClock: {
                //                     eventTime: '58:27"'
                //                 }
                //             },
                //             pr: 'SoccerMatch',
                //             fsd: new Date().toISOString()
                //         };

                //         // Моковое событие для "Линия"
                //         const mockPrematchEvent: any = {
                //             cn: 'Ахмат - Гонвед Будапешт',
                //             c: [],
                //             fi: 778,
                //             gm: [],
                //             p: [],
                //             r: false,
                //             sc: '#3FD96E',
                //             siu: '/path/to/icon',
                //             sid: 1,
                //             cid: 1,
                //             tid: 1,
                //             sn: 'Футбол',
                //             ctn: 'Международные',
                //             tn: 'Товарищеские матчи',
                //             s: 'NOT_STARTED',
                //             a: true,
                //             cl: false,
                //             su: null,
                //             st: new Date(Date.now() + 86400000).toISOString(), // Завтра
                //             pr: 'SoccerMatch',
                //             fsd: new Date().toISOString()
                //         };

                //         setFoundFixtures({
                //             ...res,
                //             live: [mockLiveEvent, ...res.live],
                //             prematch: [mockPrematchEvent, ...res.prematch]
                //         });
                //     }
                // })
                .catch(err =>
                    console.warn(
                        `there is some error while processing search fixture request... ${err}`
                    )
                );
        } else {
            setFoundFixtures(undefined);
        }
    }, [inputValue, currentTab]);
    React.useEffect(() => {
        addChar(props.char);
    }, [props.char, charLen]);

    function addChar(char: string) {
        if (inputRef.current !== null) {
            inputRef.current.focus();
            inputRef.current.value += char;
            setInputValue(inputRef.current.value);
        }
    }

    const setOpen = () => {
        props.setOpen(false);
        setFoundFixtures(undefined);
    };

    const tabs = [
        { tabId: 'ALL', tabTitle: t('results.all.tabTitle') },
        { tabId: 'NOT_STARTED', tabTitle: t('results.line.tabTitle') },
        { tabId: 'LIVE', tabTitle: t('results.live.tabTitle') }
    ];

    function handleTabChange(newValue: Tab) {
        if (onTabChange) {
            onTabChange(newValue);
        } else {
            setInternalCurrentTab(newValue);
        }
    }

    function delChar() {
        if (inputRef.current !== null) {
            inputRef.current.focus();
            inputRef.current.value = inputRef.current.value.slice(0, -1);
            setInputValue(inputRef.current.value);
        }
    }

    function renderResults() {
        if (foundFixtures) {
            return (
                <>
                    <h4 className="w-full">
                        <div className="font-medium">
                            <Fixtures
                                status={'live'}
                                tittle={'live'}
                                currentTab={currentTab}
                                needTab={'LIVE'}
                                search={foundFixtures}
                                setOpen={setOpen}
                            />
                            <Fixtures
                                status={'prematch'}
                                tittle={'line'}
                                currentTab={currentTab}
                                needTab={'NOT_STARTED'}
                                search={foundFixtures}
                                setOpen={setOpen}
                            />
                        </div>
                    </h4>
                </>
            );
        }
    }

    const add = (c: string) => {
        setCharLen(p => p + 1);
        addChar(c);
    };

    const handleClearSearch = () => {
        setInputValue('');
    }

    return (
        <div className="flex flex-col justify-center bg-[#272D33]">
            <div>
                {!hideHeader && (
                    <>
                        <div className="tablet:hidden">
                            <div className="relative flex items-center py-[10px] w-full bg-transparent">
                                <DeleteAndInputWrapperMobile>
                                    <input
                                        className="w-full px-[15px] h-7 text-white placeholder-gray-400 bg-[rgba(216,216,216,0.1)] border border-gray-400 rounded-[8px]"
                                        ref={inputRef}
                                        onChange={event =>
                                            setInputValue(
                                                event.currentTarget.value
                                            )
                                        }
                                        defaultValue="Введите поисковый запрос"
                                        autoFocus={true}
                                        placeholder={t('enter')}
                                        value={inputValue}
                                    />
                                    {inputValue && (
                                        <button
                                            onClick={handleClearSearch}
                                            className="absolute right-[8px] top-1/2 -translate-y-1/2 w-[20px] h-[20px] flex items-center justify-center cursor-pointer bg-transparent hover:bg-gray-700 rounded-full transition-colors z-10"
                                            aria-label="Clear search"
                                            type="button"
                                        >
                                            <svg
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M12.2 3.80714C11.94 3.54714 11.52 3.54714 11.26 3.80714L7.99998 7.06047L4.73998 3.80047C4.47998 3.54047 4.05998 3.54047 3.79998 3.80047C3.53998 4.06047 3.53998 4.48047 3.79998 4.74047L7.05998 8.00047L3.79998 11.2605C3.53998 11.5205 3.53998 11.9405 3.79998 12.2005C4.05998 12.4605 4.47998 12.4605 4.73998 12.2005L7.99998 8.94047L11.26 12.2005C11.52 12.4605 11.94 12.4605 12.2 12.2005C12.46 11.9405 12.46 11.5205 12.2 11.2605L8.93998 8.00047L12.2 4.74047C12.4533 4.48714 12.4533 4.06047 12.2 3.80714Z"
                                                    fill="white"
                                                />
                                            </svg>
                                        </button>
                                    )}
                                </DeleteAndInputWrapperMobile>
                            </div>
                        </div>
                        <h5 className="max-mobile:w-full max-mobile:px-[10px] max-mobile:bg-[#171a1e] desktop:mx-auto desktop:w-[54.38%]">
                            <ThemeTabs
                                handleChange={handleTabChange}
                                value={currentTab}
                                tabs={tabs}
                                containerMaxWidth={false}
                            />
                        </h5>
                    </>
                )}

                <ResultsContainer>
                    {!foundFixtures && inputValue.length === 0 ? (
                        <PlaceholderSpan>{t('searchLabel')}</PlaceholderSpan>
                    ) : (
                        renderResults()
                    )}
                </ResultsContainer>

                <div className="max-tablet:hidden">
                    <div className="grid grid-cols-[1fr_0.1fr] gap-x-[27px] mt-12 w-[81.5%] mx-auto desktop:w-[54.38%]">
                        <DeleteAndInputWrapper>
                            <input
                                className="w-full px-[15px] bg-transparent outline-none text-[#FFFFFF]"
                                ref={inputRef}
                                onChange={event =>
                                    setInputValue(event.currentTarget.value)
                                }
                                autoFocus
                                defaultValue=""
                                placeholder={t('enter')}
                                value={inputValue}
                            />
                            <DeleteKeyButtonBase
                                onClick={delChar}
                                aria-label={'Keyboard search backspace'}
                            >
                                <DeleteBackspaceIcon />
                            </DeleteKeyButtonBase>
                        </DeleteAndInputWrapper>

                        {children}
                        <div className="min-h-[21px] mb-[15px] mt-[10px] col-start-1 col-end-3">
                            {NumberUtils.between(inputValue.length, 0, 3) && (
                                <h4 className="text-[14px] text-[#FFFFFF]">
                                    {t('emptySearch3')}
                                </h4>
                            )}
                            {foundFixtures &&
                                (foundFixtures.empty ||
                                    (currentTab === 'LIVE' &&
                                        foundFixtures.live.length === 0) ||
                                    (currentTab === 'NOT_STARTED' &&
                                        foundFixtures.prematch.length === 0)) &&
                                !NumberUtils.between(
                                    inputValue.length,
                                    0,
                                    3
                                ) && (
                                    <h4 className="text-[14px] text-[#FFFFFF]">
                                        {t('emptySearch')}
                                    </h4>
                                )}
                        </div>
                    </div>
                    {checkWeb && !isWeb && <Keyboard addChar={add} />}
                </div>
            </div>
        </div>
    );
};

const TitleFixtures: React.FC<{ currentTab: Tab; tittle: 'live' | 'line'; needTab: Tab }> = ({
    currentTab,
    tittle,
    needTab
}) => {
    const { t } = useTranslation();
    const title =
        tittle === 'live'
            ? t(`results.${tittle}.sectionTitle`)
            : t(`results.${tittle}.tabTitle`);
    const shouldShow = currentTab === 'ALL' || currentTab === needTab;
    return <>{shouldShow && <Title>{title}</Title>}</>;
};

const Fixtures: React.FC<{
    status: keyof FixtureSearch;
    search: FixtureSearch;
    currentTab: Tab;
    needTab: Tab;
    tittle: 'live' | 'line';
    setOpen: () => void;
}> = ({ status, search, currentTab, tittle, needTab, setOpen }) => {
    if (status === 'live' || status === 'prematch') {
        return (
            <>
                {(currentTab === 'ALL' || currentTab === needTab) &&
                    search[status].length > 0 && (
                        <div className="mx-auto  desktop:w-[56.83%]">
                            <TitleFixtures
                                currentTab={currentTab}
                                tittle={tittle}
                                needTab={needTab}
                            />
                            {search[status].map((fixture, index) => (
                                <>
                                    <Mobile>
                                        <MatchBoxBySearchMobile
                                            setOpen={setOpen}
                                            key={index}
                                            fixture={fixture}
                                        />
                                    </Mobile>
                                    <Desktop>
                                        <MatchBoxBySearch
                                            setOpen={setOpen}
                                            key={index}
                                            fixture={fixture}
                                        />
                                    </Desktop>
                                </>
                            ))}
                        </div>
                    )}
            </>
        );
    }
    throw new Error('key ' + status + ' not live or prematch');
};

const DeleteAndInputWrapper = styled.div`
    display: flex;
    background-color: #2b3036;
    border-radius: 15px;
    border: 2px solid #7a899980;
`;

const DeleteAndInputWrapperMobile = styled.div`
    display: flex;
    background-color: #2b3036;
    border-radius: 15px;
    border: 2px solid #7a899980;
    width: 100%;
    gap: 26px;
`;

const DeleteKeyButtonBase = styled(ButtonBase)`
    background: #b1383d;
    border-radius: 13px;
    width: 96px;
    padding: 10px 27px;
` as typeof ButtonBase;

const Title = styled('h3')`
    margin-left: 40px;
    margin-top: 18px;
    margin-bottom: 8px;
    color: #ffffff;
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    text-transform: uppercase;
`;

const ResultsContainer = styled.div`
    width: 100%;
    min-height: 500px;
    overflow-y: auto;
    transition: min-height 0.2s;
    &::-webkit-scrollbar {
        width: 2px;
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: #606569;
        border-radius: 3px;
        transition: background 0.2s;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #606569;
    }

    &::-webkit-scrollbar-corner {
        background: transparent;
    }
`;

const PlaceholderSpan = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
    height: 100%;
    width: 100%;
    margin-top: 225px;
    color: #ababab;
    @media (max-width: 768px) {
        font-size: 12px;
    }
`;
